import { Pipe, PipeTransform } from '@angular/core';

import { tiposPromocoes } from '../tipo-promocao-campanha';

@Pipe({
    name: 'tipoPromocaoCampanhaApresentacao'
})
export class TipoPromocaoCampanhaApresentacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return 'Nenhuma Promoção';
        }

        const index = tiposPromocoes.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return tiposPromocoes[index].nomeApresentacao;
        }
        return '';
    }
}
